module.exports = __webpack_public_path__ + "static/media/france-3-alsace.15889b7a.svg";